export const formatCurrency = (value: number): string =>
  new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'brl',
  }).format(value)

export const formatDecimal = (value: number): string => new Intl.NumberFormat('pt-br').format(value)

export const formatInteger = (value: number): string =>
  new Intl.NumberFormat('pt-br', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })
    .format(value)
    .slice(0, -3)

export const parseNumericValue = (val: unknown): number => {
  if (typeof val === 'number') {
    return Number.isFinite(val) ? val : 0
  }
  if (typeof val === 'string') {
    const trimmed = val.trim()
    if (!trimmed) return 0
    let normalized = trimmed
    if (normalized.includes(',') && normalized.includes('.')) {
      normalized = normalized.replace(/\./g, '').replace(',', '.')
    } else if (normalized.includes(',')) {
      normalized = normalized.replace(',', '.')
    }
    normalized = normalized.replace(/[^0-9.-]/g, '')
    const parsed = Number(normalized)
    return Number.isFinite(parsed) ? parsed : 0
  }
  return 0
}
